export default __webpack_public_path__ + "static/media/413.edbae34e.gif";